import { resolveComponent as _resolveComponent, createVNode as _createVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a989df8")

_pushScopeId("data-v-0a989df8")
const _hoisted_1 = { class: "app-main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade-transform",
      mode: "out-in"
    }, {
      default: _withId(() => [
        (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.cachedViews }, [
          _createVNode(_component_router_view, { key: _ctx.key })
        ], 1032, ["include"]))
      ]),
      _: 1
    })
  ]))
})